<template>
  <v-row justify="center">
    <v-dialog v-model='bankmodal' max-width="500">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="cancel()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <br />
        <v-container>
          <v-layout row wrap justify-center>
            <br />
            <v-flex xs10 sm10 md10 lg10>
              <v-layout justify-center v-if="id">
                <br />
                <v-text-field v-model="id" label='Bank ID' required readonly filled></v-text-field>
              </v-layout>
              <v-layout justify-center>
                <v-combobox
                  v-model='bank'
                  :items='bankitems'
                  label='ธนาคาร'
                  color="pink lighten-2"
                  required
                ></v-combobox>
              </v-layout>
              <v-layout justify-center>
                <v-text-field v-model="bank_name" label='ชื่อบัญชี' required :rules="[v => !!v || 'กรุณากรอกชื่อบัญชี']" style='display:inline;' color="pink lighten-2"></v-text-field>
              </v-layout>
              <v-layout justify-center>
                <v-text-field
                  v-model="bank_no"
                  label='เลขที่บัญชี'
                  required
                  :rules="[v => !!v || 'กรุณากรอกเลขที่บัญชี']"
                  style='display:inline;'
                  color="pink lighten-2"
                  :maxlength="13"
                  v-mask="'###-#-#####-#'"
                ></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
// import axios from 'axios'
import { mask } from 'vue-the-mask'
import swal from 'sweetalert'
export default {
  directives: { mask },
  data () {
    return {
      title: 'เพิ่มบัญชี',
      currentdata: '',
      id: '',
      bank: '',
      bank_name: '',
      bank_no: '',
      bankitems: [
        'ธ.กรุงเทพ',
        'ธ.กรุงไทย',
        'ธ.กสิกรไทย',
        'ธ.ไทยพาณิชย์',
        'ธ.กรุงศรีอยุธยา',
        'ธ.ทหารไทย',
        'ธ.นครหลวงไทย',
        'ธ.ยูไนเต็ด โอเวอร์ซีส์ (ไทย)',
        'ธ.สแตนดาร์ดชาร์เตอร์ด (ไทย)',
        'ธ.ซีไอเอ็มบี ไทย',
        'ธ.ธนชาต',
        'ธ.ทิสโก้',
        'ธ.เกียรตินาคิน',
        'ธ.สินเอเซีย',
        'ธ.แลนด์ แอนด์ เฮ้าส์',
        'ธ.สากลพาณิชย์แห่งประเทศจีน',
        'ธ.ศรีนคร',
        'ธ.ดีบีเอส ไทยทนุ',
        'ธ.ยูโอบี รัตนสิน'
      ]
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    parentgetdata: ''
  },
  methods: {
    async save () {
      try {
        if (this.bank && this.bank_name && this.bank_no) {
          let tempdata = {
            bank: this.bank,
            bank_name: this.bank_name,
            bank_no: this.bank_no.replace(/-/g, '')
          }

          let swaltext = ''
          if (this.currentbankdata !== '') {
            await this.axios.put(`${process.env.VUE_APP_API}/bank/edit/${this.id}`, { ...tempdata, userid: this.id }, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกการแก้ไขข้อมูลบัญชีเรียบร้อย'
          } else {
            await this.axios.post(`${process.env.VUE_APP_API}/bank/create`, tempdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกข้อมูลบัญชีใหม่เรียบร้อย'
          }

          this.bankmodal = false
          await swal(swaltext, {
            icon: 'success',
            buttons: 'ตกลง'
          })
          this.parentgetdata()
        } else {
          await swal({
            title: `กรุณากรอกข้อมูลบัญชีธนาคารให้ครบถ้วน`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    cancel () {
      this.currentbankdata = ''
      this.bankmodal = false
    }
  },
  computed: {
    bankmodal: sync('bankmodal'),
    currentbankdata: sync('currentbankdata')
  },
  watch: {
    currentbankdata () {
      if (this.currentbankdata !== '') {
        this.currentdata = JSON.parse(this.currentbankdata)
        this.id = this.currentdata._id
        this.bank = this.currentdata.bank
        this.bank_name = this.currentdata.bank_name
        const bank = this.currentdata
        this.bank_no = `${bank.bank_no.slice(0, 3)}-${bank.bank_no.slice(3, 4)}-${bank.bank_no.slice(4, 9)}-${bank.bank_no.slice(9, 10)}`
        this.title = `แก้ไขบัญชี`
      } else {
        this.id = ''
        this.bank = ''
        this.bank_name = ''
        this.bank_no = ''
        this.title = `เพิ่มบัญชี`
      }
    }
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.inputstyle {
  font-style: normal;
  font-weight: normal;
}
.v-text-field {
    font-family: 'Kanit';
}

.v-btn {
    font-family: 'Kanit';
    font-weight: bold;
}

p {
    font-family: 'Kanit';
}
.v-list-item__title {
  font-family: 'Kanit';
}
</style>
